export function generateSlug(name: string, id: string): string {
  const namePart = name
    .toLowerCase()
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'o')
    .replace(/å/g, 'a')
    .replace(/[^a-z0-9]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .substring(0, 24);
  const shortId = id.replace(/-/g, '').substring(0, 6);
  return `${namePart}-${shortId}`;
}
